/* eslint-disable react/no-unused-state */
import * as partnerPlanFormSchema from 'schemas/forms/PartnerPlanForm'
import Heading from 'components/Heading'
import Modal from 'components/Modal'
import { validateAll } from 'utils/validators'
import React, { PropTypes, Component } from 'react'
import SelectInput from 'components/Form/components/SelectInput'
import SubmitButton from 'components/SubmitButton'
import TextInput from 'components/Form/components/TextInput'
import Checkbox from 'components/Form/components/Checkbox'
import Alert from 'components/Alert'
import styles from './PartnerPlanDisplayForm.scss'
import constants from 'constants'
// import moment from 'moment'
import { format } from 'date-fns'
import { trimString } from 'utils/stringUtils'

import {
  formUpdate,
  formInit,
  formSubmit,
  formReset,
} from 'actions/forms'

class FinalCounsellorPlanDisplayForm extends Component {
  static propTypes = {
    completeText: PropTypes.string,
    confirmation: PropTypes.bool,
    ctaText: PropTypes.string,
    data: PropTypes.object,
    description: PropTypes.string,
    dispatch: PropTypes.func.isRequired,
    forms: PropTypes.object.isRequired,
    handleFormSubmit: PropTypes.func,
    handleSubmit: PropTypes.func.isRequired,
    hide: PropTypes.func.isRequired,
    id: PropTypes.string,
    modals: PropTypes.object.isRequired,
    partnerPlan: PropTypes.object,
    selectedPlan: PropTypes.object.isRequired,
    show: PropTypes.bool,
    submittingText: PropTypes.string,
    title: PropTypes.string,
  }
  static defaultProps = {
    data: {},
    ctaText: 'Submit',
    completeText: 'Submitted',
    submittingText: 'Submitting',
    show: false,
    confirmation: false,
    description: '',
    handleFormSubmit: null,
    id: `${constants.PARTNERPLAN.FORMS.FINAL_COUNSELLOR}`,
    title: '',
    partnerPlan: null,
  }
  /* **use for notes dropdown selection**
  constructor(props) {
    super(props)
    this.state = {
      finalCounsellorCommentsOtherSelected: false,
    }
  } */
  componentWillMount() {
    const { formFields } = partnerPlanFormSchema

    const formData = {
      formFields,
      data: this.props.data || null,
    }

    this.props.dispatch(formInit(this.props.id, formData))
  }

  componentWillReceiveProps(nextProps) {
    const modalCreated = this.props.modals.finalCounsellorPlanForm
    const modalChanged = modalCreated && nextProps.modals.finalCounsellorPlanForm.show !== this.props.modals.finalCounsellorPlanForm.show
    const modalNotVisible = modalCreated && !nextProps.modals.finalCounsellorPlanForm.show
    const modalVisible = modalCreated && nextProps.modals.finalCounsellorPlanForm.show
    // const dataChanged = nextProps.data !== this.props.data

    if (modalChanged && modalNotVisible) {
      this.props.dispatch(formReset(this.props.id))
    }

    if (modalChanged && modalVisible) {
      // preload data from BED if needed
      const partnerPlanData = this.props.partnerPlan.partnerPlan
      this._handleChange('role', this.props.selectedPlan.Role)
      this._handleChange('planStatus', partnerPlanData.planStatus)
      this._handleChange('partnerFinalAssessment', partnerPlanData.finalCounselleeAssessment)
      this._handleChange('partnerFinalAssessmentComments', partnerPlanData.finalCounselleeComments)
      this._handleSelectChange('finalCounsellorAssessment', (partnerPlanData.finalCounsellorAssessment !== '' ?
        partnerPlanData.finalCounsellorAssessment : ''))
      this._handleChange('finalCounsellorComments', partnerPlanData.finalCounsellorComments)
      this._handleChange('finalPlanAgreedWithCounsellee', partnerPlanData.finalPlanAgreedWithCounsellee)

      partnerPlanData.finalCounsellorComments = (partnerPlanData.finalCounsellorComments ? partnerPlanData.finalCounsellorComments : '')
      /* **use for notes dropdown selection**
      if (partnerPlanData.finalCounsellorComments.indexOf('Other') > -1) {
        const finalCounsellorComments = partnerPlanData.finalCounsellorComments.split(':')
        if (finalCounsellorComments) {
          this.setState({ finalCounsellorCommentsOtherSelected: true })
          this._handleSelectChange('finalCounsellorCommentsOther', (finalCounsellorComments[1] !== ''
            ? finalCounsellorComments[1] : ''))
          this._handleSelectChange('finalCounsellorComments', (finalCounsellorComments[0] !== ''
            ? finalCounsellorComments[0].trim() : ''))
        } else {
          this.setState({ interimCounsellorCommentsOtherSelected: false })
          this._handleSelectChange('finalCounsellorComments', (partnerPlanData.finalCounsellorComments !== ''
            ? partnerPlanData.finalCounsellorComments : ''))
        }
      } */
    }
  }

  _schema = () => {
    const obj = {}
    partnerPlanFormSchema.formFields.forEach((field) => {
      obj[field.name] = field
    })
    return obj
  }

  _hide = () => {
    this.props.hide(this.props.id)
    this.props.dispatch(formReset(this.props.id))
  }

  _handleSubmit = (e) => {
    e.preventDefault()
    const values = this.props.forms[this.props.id]
    const data = {}
    Object.keys(values).forEach((key) => {
      if (key.indexOf('_') < 0) {
        data[key] = values[key].value
      }
    })

    // Validate all the forms fields and return any errors
    const errors = validateAll(partnerPlanFormSchema.requiredFields, this.props.forms[this.props.id])
    // Check if form has errors
    if (errors.length > 0) {
      // If form has errors handle them
      errors.forEach((errObj) => {
        this._handleError(errObj, errObj.name)
      })
    } else {
      // If form has no errors, pass the serialized form field for submit and set the form to submit.
      // append or map existing data
      data.year = (this.props.selectedPlan.PlanYear ? this.props.selectedPlan.PlanYear : '')
      data.planStatus = constants.PARTNERPLAN.STATUS.FINAL_ASSESSMENT_AGREED
      // data.finalAgreedDate = `${moment(new Date()).format()}`
      data.finalAgreedDate = `${format(new Date(), constants.DATE_FORMAT.STANDARD_ISO)}`
      if (data.finalCounsellorComments === 'Other') {
        data.finalCounsellorComments = `${data.finalCounsellorComments}:${data.finalCounsellorCommentsOther}`
      }
      this.props.dispatch(formSubmit(this.props.id))
      this.props.handleSubmit(data)
    }
  }

  // Takes an error object for a field and updates the state accordingly
  _handleError(errorObj, stateKey) {
    // Set new state value for field and update state
    const stateValue = {
      data: {
        focus: false,
        error: (errorObj.valid) ? '' : errorObj.error,
        valid: errorObj.valid,
      },
      field: stateKey,
    }
    this._handleState(stateValue)
  }

  _handleState = (stateValue) => {
    this.props.dispatch(formUpdate(this.props.id, stateValue))
  }

  _handleValidation = (name) => {
    const stateValue = {
      field: name,
      data: {
        focus: false,
      },
    }

    this.props.dispatch(formUpdate(this.props.id, stateValue))
  }

  _handleFocus = (name) => {
    // Create state value obj
    const stateValue = {
      field: name,
      data: {
        focus: true,
      },
    }

    this.props.dispatch(formUpdate(this.props.id, stateValue))
  }

  _handleAutoComplete = (name, value) => {
    this._handleChange(name, value)
  }

  // Handle Changes on form elements
  _handleChange = (name, value) => {
    /*
      Create state value obj
      Reset error handling (Stops error check on focus changes)
    */
    const stateValue = {
      field: name,
      data: {
        value,
        error: '',
        valid: true,
      },
    }
    // Pass state value and handle state
    this.props.dispatch(formUpdate(this.props.id, stateValue))
  }

  _handleSelectChange = (name, value, selectedIndex) => {
    /*
      Create state value obj
      Reset error handling (Stops error check on focus changes)
    */
    const stateValue = {
      field: name,
      data: {
        value,
        error: '',
        valid: true,
        selectedIndex,
      },
    }

    switch (name) {
      case 'finalCounsellorComments':
        /* **use for notes dropdown selection**
        this.setState({ finalCounsellorCommentsOtherSelected: false })
        if (value && value.indexOf('Other') > -1) {
          this.setState({ finalCounsellorCommentsOtherSelected: true })
          this._handleSelectChange('finalCounsellorCommentsOther', '')
        } */
        break
      default:
        break
    }

    // Pass state value and handle state
    this.props.dispatch(formUpdate(this.props.id, stateValue))
  }

  canSubmit = () => {
    const form = this.props.forms[this.props.id]
    return form.finalCounsellorAssessment.value
    && form.finalPlanAgreedWithCounsellee.value
    && trimString(form.finalCounsellorComments.value) !== ''
    /* **use for notes dropdown selection**
    && !(form.partnerFinalAssessment.value !== form.finalCounsellorAssessment.value && form.finalCounsellorComments.value === '') */
  }

  render() {
    const {
      ctaText,
      completeText,
      submittingText,
      title,
      dispatch,
      modals,
      description,
    } = this.props
    const schema = this._schema()
    const form = this.props.forms[this.props.id]
    const disable = (form && form._isPosting)
    const forceClose = (form && form._hasCompleted)
    const formHasFetched = this.props.hasFetched
    return (
      <Modal
        className={styles.bg}
        disable={disable}
        dispatch={dispatch}
        forceClose={forceClose}
        id={constants.PARTNERPLAN.FORMS.FINAL_COUNSELLOR}
        modals={modals}
        onClose={this._hide}
      >
        <div className={styles.base}>
          <Heading className={styles.title} size="large">
            {title}
          </Heading>
          <p className={styles.content}>{description}</p>
          <Alert type="info">
              Please fill out the assessment rating and notes before submitting the assessment.<br />
              Once you submit your assessment rating it cannot be changed.
          </Alert>
          {form &&
          <form
            className={styles.form}
            id={this.props.id}
            noValidate="novalidate"
            onSubmit={this._handleSubmit}
          >
            <div className={styles.sectionHeader} />
            <fieldset>
              <ul>
                <TextInput
                  {...schema.planStatus}
                  handleChange={this._handleChange}
                  onBlur={this._handleValidation}
                  onFocus={this._handleFocus}
                  text={form.planStatus.value}
                />
                <TextInput
                  {...schema.role}
                  handleChange={this._handleChange}
                  onBlur={this._handleValidation}
                  onFocus={this._handleFocus}
                  text={form.role.value}
                />
                <li>
                  <TextInput
                    {...schema.partnerFinalAssessment}
                    disabled
                    error={form.partnerFinalAssessment.error}
                    focus={form.partnerFinalAssessment.focus}
                    handleChange={this._handleChange}
                    onBlur={this._handleValidation}
                    onFocus={this._handleFocus}
                    text={form.partnerFinalAssessment.value}
                  />
                </li>
                {this.props.partnerPlan.partnerPlan.finalCounselleeComments && <li>
                  <TextInput
                    {...schema.partnerFinalAssessmentComments}
                    disabled
                    multiline
                    error={form.partnerFinalAssessmentComments.error}
                    focus={form.partnerFinalAssessmentComments.focus}
                    handleChange={this._handleChange}
                    onBlur={this._handleValidation}
                    onFocus={this._handleFocus}
                    text={form.partnerFinalAssessmentComments.value}
                    valid={form.partnerFinalAssessmentComments.valid}
                  />
                </li> }                
                <li>
                  <SelectInput
                    {...schema.finalCounsellorAssessment}
                    floatedLabel
                    searchable
                    error={form.finalCounsellorAssessment.error}
                    handleChange={this._handleSelectChange}
                    onBlur={this._handleValidation}
                    options={constants.PARTNERPLAN_LIST_OPTIONS.RATINGS} // load from BED?
                    valid={form.finalCounsellorAssessment.valid}
                    value={form.finalCounsellorAssessment.value}
                  />
                </li>
                <li>
                  { /* **use for notes dropdown selection**
                   <SelectInput
                    {...schema.finalCounsellorComments}
                    floatedLabel
                    searchable
                    error={form.finalCounsellorComments.error}
                    handleChange={this._handleSelectChange}
                    onBlur={this._handleValidation}
                    options={constants.PARTNERPLAN_LIST_OPTIONS.COUNSELLOR_PARTNER} // load from BED?
                    valid={form.finalCounsellorComments.valid}
                    value={form.finalCounsellorComments.value}
                  /> */ }
                  {/* this.state.finalCounsellorCommentsOtherSelected &&
                  <TextInput
                    {...schema.finalCounsellorCommentsOther}
                    multiline
                    error={form.finalCounsellorCommentsOther.error}
                    focus={form.finalCounsellorCommentsOther.focus}
                    handleChange={this._handleChange}
                    onBlur={this._handleValidation}
                    onFocus={this._handleFocus}
                    text={form.finalCounsellorCommentsOther.value}
                    valid={form.finalCounsellorCommentsOther.valid}
                  /> */}
                  <TextInput
                    {...schema.finalCounsellorComments}
                    multiline
                    error={form.finalCounsellorComments.error}
                    focus={form.finalCounsellorComments.focus}
                    handleChange={this._handleChange}
                    onBlur={this._handleValidation}
                    onFocus={this._handleFocus}
                    text={form.finalCounsellorComments.value}
                    valid={form.finalCounsellorComments.valid}
                  />
                </li>
                <li>
                  <br /><Checkbox
                    {...schema.finalPlanAgreedWithCounsellee}
                    checked={!!form.finalPlanAgreedWithCounsellee.value}
                    handleChange={this._handleChange}
                  />
                </li>
              </ul>
            </fieldset>
            <br /><br />
            <div className={styles.footer}>
              <SubmitButton
                isLarge
                complete={this.props.forms[this.props.id]._isComplete}
                completeText={completeText} // Add validation rules
                disabled={!this.canSubmit()}
                submitting={this.props.forms[this.props.id]._isPosting}
                submittingText={submittingText}
              >
                {ctaText}
              </SubmitButton>
            </div>
          </form>
        }
        </div>
      </Modal>
    )
  }
}

export default FinalCounsellorPlanDisplayForm



// WEBPACK FOOTER //
// ./src/views/PartnerPlans/FinalCounsellorPlanDisplayForm.js